import { createStyles, makeStyles } from '@material-ui/core/styles';

const styles = makeStyles((theme) =>
  createStyles({
    noHeader: {
      marginBottom: -72,
    },
    header: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      zIndex: 1,
      backgroundColor: theme.oysterTheme.cotton,
    },
    headerLogo: {
      width: '55px',
      height: '55px',
    },
    headerText: {
      fontWeight: 500,
      fontSize: 14,
      padding: 8,
      color: theme.oysterTheme.pearl,
      whiteSpace: 'nowrap',
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
    },
    headerContent: {
      display: 'flex',
      backgroundColor: theme.oysterTheme.charcoal,
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '0 .5rem',
    },
    button: {
      backgroundColor: theme.oysterTheme.brandGreen,
      padding: '8px 16px',
      height: 32,
      width: 96,
      border: 'none',
      borderRadius: 16,
      cursor: 'pointer',
      outline: 'none',
    },
    contentWrapper: {
      flex: 1,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      height: '72px',
      padding: '0 .5rem',
    },
  }),
);

export default styles;
